import { computed } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { coverageAlertsApi } from '@/api/coverage-alerts';
import { useUser } from './useUser';
import { usePermissions } from './usePermissions';

// Coverage alerts follow care planning (CoverageAlertPolicy): the company has it on and
// the user reads requirements.
export function useCanSeeCoverageAlerts() {
  const { user } = useUser();
  const { hasPermission } = usePermissions();

  return computed(() => !!user?.value?.companyCarePlanningEnabled &&
    hasPermission.value('requirements', 'index'));
}

const REFRESH_MS = 300_000; // the scan runs every 5 minutes

// The nav badge: every open alert the user can see. The panel's open tab extends this
// key with its filters, so invalidating ['coverageAlerts', 'open'] refreshes both.
export function useOpenCoverageAlertsCount() {
  const canSee = useCanSeeCoverageAlerts();
  const { data } = useQuery({
    queryKey: ['coverageAlerts', 'open'],
    queryFn: () => coverageAlertsApi.index({ status: 'open' }),
    enabled: canSee,
    refetchInterval: REFRESH_MS,
    staleTime: REFRESH_MS,
  });

  return computed(() => (canSee.value ? data.value?.length ?? 0 : 0));
}
